module.exports = __webpack_public_path__ + "media/flip.20d298ae.mp3";